import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GitHistoryDialogComponent, GitHistoryDialogParams } from '../git-history-dialog';

@UntilDestroy()
@Component({
  selector: 'y42-git-file-editor',
  templateUrl: './git-file-editor.component.html',
  styleUrls: ['./git-file-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitFileEditorComponent {
  constructor(private readonly dialog: MatDialog) {}

  @Input() filePath = '';
  @Input() isRoundBtn = true;

  openHistory() {
    this.dialog.open<GitHistoryDialogComponent, GitHistoryDialogParams>(GitHistoryDialogComponent, {
      width: '100%',
      height: '80vh',
      autoFocus: false,
      data: { filePath: this.filePath },
    });
  }
}
